<template>
	<div class="sideBar">
		
        <header class="sideBarHeader">
			<h2 class="sideBarHeaderTitle">{{notesTitle}}</h2>
			<a href="#" class="sideBarHeaderSubtitle">{{notesSubTitle}}</a>
            <a @click="$emit('closeSideBar')" class="sideBarCloseIcon cursor">
				<i class="fa-solid fa-xmark"></i>
			</a>
		</header>

        <NotesApp
            :_data="_data"
        />

       

    </div>


   
</template>

<script>
import NotesApp from '../Notes/NotesApp.vue';
export default {
    emits:['showActionBar', 'closeActionBar', 'showAlert'],
    components:{NotesApp},
    props: {
        _data: {type:Object, required:true}
        
    },
    data() {
        return {
            newNote: ''
        }
    },
    computed: {
        notesTitle() {            
            console.log('notesTitle', this._data)
            switch(this._data._class) {
                case 'Contact':
                    return this._data.fullname||'Notitie';
                    break;    
                case 'Organisation':
                    return this._data.name||'Notitie';
                    break;            
                case 'Prospect':
                    return this._data.fullname||'Notitie';
                    break;            
                case 'Panelmember':
                    return this._data.fullname||'Notitie';
                    break;            
                case 'Consortium':
                    return this._data.name||'Notitie';
                    break;            
                case 'Submission':
                    return this._data.fullname||'Notitie';
                    break;
            }
        },
        notesSubTitle() {
            var html = [];
            switch(this._data._class) {
                case 'Contact':
                    return this._data.Organisation.name;             
                    break;
                case 'Prospect':
                    return this._data.organisation;
                    break;
                case 'Organisation':
                    return this._data.city;
                    break;
                case 'Consortium':
                    return this._data.Contact.contactOrganisationName;
                    break;
                case 'Panelmember':
                    return this._data.organisation;
                    break;
                case 'Submission':
                    return this._data.organisation;
                    break;
                default:
                    return ''
            }
        }
    },
    methods: {
        async addNote() {
            console.log('addNote', this.$props._data, this.newNote)
            var postData = {};
            postData[this.$props._data._idfield] = this.$props._data.id;
            postData['text'] = this.newNote;
            
            const res = await this.callApi('post', '/notes', postData);

            this.$props._data.Notes = res.data.result.Notes;
            this.newNote = '';
        }
    }
}
</script>

<style scoped>


</style>